<ng-container>
  <header class="header">
    <div class="close-button" onclick="history.back()"></div>
    <p class="text-h5">仮登録完了</p>
    <!---->
  </header>

  <div
    class="text-center header-img"
    style="
      background: linear-gradient(
          0deg,
          rgba(177, 220, 241, 0.4),
          rgba(177, 220, 241, 0.4)
        ),
        #ffffff;
    "
  >
    <img
      src="/assets/sgzp-master/images/password-reset-send_main.svg"
      width="302"
      height="133"
      alt="SgzpMaster"
    />
  </div>
  <div class="container isBackgoround">
    <main>
      <div class="container_min">
        <!-- <h2 class="text-h6 font-weight-bold text-center mb-6">
          リセット用URLをメールで送信しました
        </h2> -->
        <p style="font-size: 28px; font-weight: 600; margin-bottom: 10px">
          認証メールを確認してください
        </p>

        <div style="margin-top: 10px">
          <p class="text-caption text-center mb-6 v-text">
            登録したメールアドレスに送信した認証メールを確認し、登録を完了してください。
          </p>
        </div>

        <div
          class="v-card v-sheet theme--light elevation-0"
          style="
            background-color: var(--color-100-bold);
            border-color: var(--color-100-bold);
          "
        >
          <div class="v-card__title text-caption" style="margin-top: 40px">
            <div style="padding: 10px">
              <p
                class="text-subtitle-1 d-flex align-center mb-2"
                style="height: 28px; display: flex; align-items: center"
              >
                <!-- <img
                  src="/assets/sgzp-master/images/icon-help.svg"
                  alt=""
                  style="margin-right: 0.2em"
                /> -->
                <i
                  id="icon-question"
                  aria-hidden="true"
                  class="v-icon notranslate v-icon--left mdi mdi-help-circle theme--right"
                ></i>
                <span class="v-text">メールが届かない場合</span>
              </p>
              <p class="text-black-58">
                dx-utility.comのドメインからメールが届きます。認証メールが届かない場合は、迷惑メールフォルダに入る設定となっていないかご確認ください。
              </p>
              <p class="text-black-58">
                認証メールの再送信は
                <a
                  [routerLink]="['/', 'register-resend']"
                  queryParamsHandling="preserve"
                  class="text-link"
                  >こちら</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</ng-container>
